import { render, staticRenderFns } from "./CenterSelector.vue?vue&type=template&id=a450955e&"
import script from "./CenterSelector.vue?vue&type=script&lang=ts&"
export * from "./CenterSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports